import { useHistory } from 'react-router-dom';
import { Path } from '@components/routes/constants';
import useStores from '@stores/useStores';

/**
 * Shared hook for navigating to the plans/upgrade page.
 * Used by all trial container components.
 */
export const useUpgradeNavigation = () => {
  const { userStore } = useStores();
  const history = useHistory();
  if (!userStore.isOrgAdmin) {
    return undefined;
  }
  return () => {
    history.push(`${Path.ORGANIZATION}?tab=plans`);
  };
};
